module.exports = __webpack_public_path__ + "static/media/star-big-05.4888b95d.svg";